module.exports = __webpack_public_path__ + "img/fi-rr-video-camera.b1864242.svg";